import { AMEND_FOUND_ADDRESSEE } from 'redux/modules/address-suggestion/actions/types';

export const amendFoundAddressee = addressee => ({
  type: AMEND_FOUND_ADDRESSEE,
  addressee,
});
